import { render } from "./RedeemVoucher.vue?vue&type=template&id=fabe9884"
import script from "./RedeemVoucher.vue?vue&type=script&lang=ts"
export * from "./RedeemVoucher.vue?vue&type=script&lang=ts"
script.render = render

export default script